import PatientSignatureImage from './PatientSignatureImage';
import InitialsField from './InitialsField';

const FinancialConsent = ({
    pageRefs,
    currentPage,
    logo,
    pageTitles,
    SurgeryFormData,
    surgeonOptionsMap,
    docSignature,
    setSignatures,
    setSurgeryFormData,
    handleInputChange,
    invalidFields,
    isNext,
    isEditing,
    signatures,
    canvasRefs,
    updateSignatureData,
    clearSignature,
    toggleEditMode,
    getCentralAmericaDate,
    getCentralAmericaTime,
    Logo,
    Head,
    Paragraph,
    RadioGroup,
    TextInput,
    SignatureField,
    SegLogoBanner,
    Initials,
    surgeryUpload,
    FormInput,
    SelectInput,
    surgicalLocation,
    SegFooter,
    formattedDate
}) => {

    return (
        <div ref={pageRefs.current[currentPage]} className="max-w-5xl w-full bg-white">
            <SegLogoBanner src={logo} />
            <div className="px-1 mx-8 py-2">
                <Head title="Financial Consent" />
                <Paragraph className="whitespace-nowrap">
                    Patient Name:{" "}
                    <span className="underline font-bold">
                        {`${SurgeryFormData.first_name} ${SurgeryFormData.last_name}`}
                    </span>{" "}
                    DOB: <span className="underline font-bold">{SurgeryFormData.dob}</span>
                </Paragraph>

                <TextInput
                    id="surgeon"
                    label="Planned Surgeon"
                    value={SurgeryFormData.surgeon}
                    onChange={handleInputChange}
                    disabled={true}
                    invalid={invalidFields.includes("surgeon") && !SurgeryFormData.surgeon}
                />

                <Paragraph>
                    Our financial counselor will be in contact with you if there is an estimated expense due prior to surgery. They will
                    inform you of your estimated physician surgical charges. This is only an estimate based on your insurance benefits
                    and is not a guarantee of payment. You are responsible for any deductibles, co-payments, or coinsurance as
                    determined by your insurance carrier. While we will try to assist you if you have any questions, it is your
                    responsibility to understand your insurance and its specific requirements.
                </Paragraph>
                <Paragraph>
                    You may be asked to see your primary care physician and to have laboratory tests or other diagnostic procedures.
                    You will receive separate billing for these services that are not included in the estimate below. Additionally, the
                    cost of glasses purchased post-operatively is not included in this estimate.
                </Paragraph>
                <Paragraph>
                    You may be asked to see your primary care physician and to have laboratory tests or other diagnostic procedures.
                    You will receive separate billing for these services that are not included in the estimate below. Additionally, the
                    cost of glasses purchased post-operatively is not included in this estimate.
                </Paragraph>
                <Paragraph>
                    Payment of the estimated patient expenses is due <span className="font-bold">one week</span> prior to the expected date of surgery. We accept cash,
                    checks, Visa, Mastercard, American Express, Discover and Care Credit.
                </Paragraph>


                <TextInput
                    id="surgeon"
                    label="Planned Surgeon"
                    value={SurgeryFormData.surgeon}
                    onChange={handleInputChange}
                    disabled={true}
                    invalid={invalidFields.includes("surgeon") && !SurgeryFormData.surgeon}
                />

                <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {[
                        {
                            id: "surgery_1_date",
                            label: "Surgery Date #1:",
                            required: false,
                        },
                        {
                            id: "surgery_1_type",
                            label: "Surgery Type:",
                            required: false,
                        }
                    ].map(({ id, label, required }) => (
                        <FormInput
                            key={id}
                            id={id}
                            label={label}
                            type="text"
                            disabled={isNext}
                            value={SurgeryFormData[id]}
                            onChange={handleInputChange}
                            invalid={invalidFields.includes(id) && !SurgeryFormData[id]}
                            required={required}
                        />
                    ))}
                </div>

                <div className="my-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {[
                        {
                            id: "surgery_2_date",
                            label: "Surgery Date #2:",
                            required: false,
                        },
                        {
                            id: "surgery_2_type",
                            label: "Surgery Type:",
                            required: false,
                        }
                    ].map(({ id, label, required }) => (
                        <FormInput
                            key={id}
                            id={id}
                            label={label}
                            type="text"
                            disabled={isNext}
                            value={SurgeryFormData[id]}
                            onChange={handleInputChange}
                            invalid={invalidFields.includes(id) && !SurgeryFormData[id]}
                            required={required}
                        />
                    ))}
                </div>

                <TextInput
                    id="specialty_lens_cost"
                    label="Non-Covered Services (Specialty Lens Cost):"
                    value={SurgeryFormData.specialty_lens_cost}
                    onChange={handleInputChange}
                    disabled={surgeryUpload}
                    invalid={invalidFields.includes("specialty_lens_cost") && !SurgeryFormData.specialty_lens_cost}
                />

                <div className="mb-4">
                    <InitialsField
                        FormData={SurgeryFormData}
                        Para="Your insurance will be billed separately for the physician, facility, and anesthesia services. You may be responsible for a copay or deductible, depending on your insurance coverage . If you have questions about charges for the facility or anesthesia, please reach out directly to the surgical facility. Please note that our office only handles billing related to the physician’s services."
                        id="billing_agreement"
                        value={SurgeryFormData.billing_agreement}
                        onChange={(fieldId, fieldValue) =>
                            setSurgeryFormData((prev) => ({
                                ...prev,
                                [fieldId]: fieldValue,
                            }))
                        }
                        isInvalid={invalidFields.includes("billing_agreement") && !SurgeryFormData.billing_agreement}
                        required={true}
                        disabled={isNext}
                    />
                </div>

                <div className="mb-4">
                    <InitialsField
                        FormData={SurgeryFormData}
                        Para="If your upcoming surgery includes a specialty lens, there will be an additional charge that you will need to pay directly to the facility. This fee is separate from and in addition to the physician’s fee."
                        id="glasses_payment_agreement"
                        value={SurgeryFormData.glasses_payment_agreement}
                        onChange={(fieldId, fieldValue) =>
                            setSurgeryFormData((prev) => ({
                                ...prev,
                                [fieldId]: fieldValue,
                            }))
                        }
                        isInvalid={invalidFields.includes("glasses_payment_agreement") && !SurgeryFormData.glasses_payment_agreement}
                        required={true}
                        disabled={isNext}
                    />
                </div>


                <div className="mb-4 flex flex-col sm:flex-row sm:items-start gap-6">
                    <SelectInput
                        id="surgery_center"
                        label=""
                        options={Array.isArray(surgicalLocation) ? surgicalLocation : []}
                        value={SurgeryFormData.surgery_center}
                        onChange={(e) =>
                            setSurgeryFormData((prev) => ({
                                ...prev,
                                surgery_center: e.target.value,
                            }))
                        }
                        disabled={surgeryUpload}
                        invalid={invalidFields.includes("surgery_center") && !SurgeryFormData.surgery_center}
                    /> <span> WILL CONTACT YOU WITH YOUR FACILITY AND ANESTHESIA FEES</span>
                </div>

                <div className="mb-4">
                    <PatientSignatureImage
                        signature={SurgeryFormData['patient_signature']}
                        label="Patient Signature"
                        signedDate={`${SurgeryFormData.patientSignedDate} ${SurgeryFormData.patientSignedTime}`}
                    />
                </div>


                <div className="mb-4 flex flex-col sm:flex-row sm:items-start gap-6">
                    {/* Signature */}
                    <PatientSignatureImage
                        signature={SurgeryFormData['doctor_signature']}
                        label="Physician/Surgeon"
                        signedDate={formattedDate}
                    />
                </div>


            </div>
            <div className="mb-2">
                <SegFooter />
            </div>
        </div>
    );
};

export default FinancialConsent;